module.exports = __webpack_public_path__ + "static/media/sms_icon.b54702a8.svg";